<template>
  <div class="card tab-card">
    <div class="card__thumbnail tab-card__thumbnail">
      <div class="card__discount" v-if="getDiscountPercentage(oferta) > 5">
        <span class="badge badge_discount">-{{ discount }}%</span>
      </div>
      <img
        :src="getUrl(oferta)"
        @error="onImageError"
        @load="hideLoader"
        :alt="oferta.ofr.obj.name"
      />
      <span class="image-loader">
        <loading-spinner :size="24" />
      </span>
    </div>
    <div class="card__content tab-card__content">
      <div class="mb-12">
        <div class="card__regions">
          <template
            v-if="
              getUrlLocid(oferta) == '' || getDomainType('travelone', 'skione')
            "
          >
            <T1CardBreadcrumbs :items="getBreadcrumbs(oferta)" />
          </template>
          <template v-else>
            <!-- <T1CardBreadcrumbs :items="getBreadcrumbs(oferta)" /> -->
            <T1CardBreadcrumbs :locid="getUrlLocid(oferta)" />
          </template>
        </div>
        <h3 class="card__hotel-name tab-card__hotel-name mb-2">
          <a :href="getUrlOferta(oferta)" :title="oferta.ofr.obj.name">{{
            oferta.ofr.obj.name
          }}</a>
        </h3>
        <T1Stars class="card__category" :number="oferta.ofr.obj.category" />
      </div>
      <div class="card__details">
        <T1TripDetails
          :dateFrom="formatData(oferta.ofr.trp.startDate)"
          :dateTo="formatData(oferta.ofr.trp.rDesDate)"
          :depDesc="oferta.ofr.trp.depDesc"
          :duration="oferta.ofr.trp.duration"
          :service="getWyzywienie(oferta.ofr.obj.xServiceId)"
          :touropName="getTourop(oferta.ofr.tourOp)"
          :type="oferta.ofr.type"
          class="mb-12"
          iconSize="14"
        />
        <div class="card__price tab-card__price">
          <div v-if="getDiscountPercentage(oferta) > 5">
            <span class="font-14 gray-30 text-crossed"
              >{{ getMaxPrice(oferta) }} zł/os.</span
            >
          </div>
          <div class="ml-8">
            <span>od: </span>
            <span class="font-22">{{ oferta.ofr.price }}</span>
            <span class="font-16"> zł/os.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { tourop } from "../tourops.js";
import { wyzywienie } from "../wyzywienie.js";
import T1CardBreadcrumbs from "../T1Breadcrumbs/T1CardBreadcrumbs";
import T1Stars from "../T1Shared/T1Stars";
import T1TripDetails from "./T1TripDetails";
import { domainTypeMixin } from "@/mixins/domainTypeMixin";

export default {
  mixins: [domainTypeMixin],
  name: "tab-card",
  props: {
    oferta: Object,
  },
  data: () => ({
    imageLoaded: false,
    tourop: tourop.tourops,
    wyzyw: wyzywienie.wyz,
  }),
  methods: {
    hideLoader(e) {
      const loaderElem = e.target.nextElementSibling;
      loaderElem.classList.add("_hiding");

      setTimeout(() => {
        loaderElem.remove();
      }, 150);
    },
    getBreadcrumbs(oferta) {
      let crumbsArr = [];

      if (
        (oferta.ofr.obj.type != "R" &&
          oferta.ofr.obj.region != "Wyc. objazdowe") ||
        oferta.ofr.obj.xCity != "Wyc. objazdowe"
      ) {
        if (typeof oferta.ofr.obj.country === "string") {
          crumbsArr.push({ name: oferta.ofr.obj.country, link: "" });
        }
        if (typeof oferta.ofr.obj.region === "string") {
          crumbsArr.push({ name: oferta.ofr.obj.region, link: "" });
        }
        if (
          typeof oferta.ofr.obj.xCity === "string" &&
          oferta.ofr.obj.xCity != oferta.ofr.obj.region
        ) {
          crumbsArr.push({ name: oferta.ofr.obj.xCity, link: "" });
        }
      } else {
        crumbsArr.push({
          name: oferta.ofr.obj.country + ": wycieczki objazdowe",
          link: "",
        });
      }
      return crumbsArr;
    },
    formatData(data) {
      if (data != "" && data.length >= 8) {
        return (
          data.substring(6) +
          "." +
          data.substring(4, 6) +
          "." +
          data.substring(0, 4)
        );
      } else {
        return "";
      }
    },
    getUrl(oferta) {
      if (
        oferta.ofr &&
        oferta.ofr.datagourl !== undefined &&
        oferta.ofr.datagourl != ""
      ) {
        return "https://" + oferta.ofr.datagourl.replace(/T320/i, "T640");
      } else {
        return (
          "https://data2.merlinx.pl/" +
          oferta.ofr.tourOp +
          "/" +
          oferta.ofr.tourOp +
          "-" +
          oferta.ofr.obj.code +
          "-0.jpg"
        );
      }
    },
    getUrlLocid(oferta) {
      if (oferta.ofr.hlocid != "") {
        return oferta.ofr.hlocid;
      } else {
        return "";
      }
    },
    getFromDate(data) {
      if (data != null && data != "" && data.length >= 8) {
        return data.substring(4, 6) + data.substring(6);
      } else {
        return "";
      }
    },
    getHref(hurl) {
      if (hurl != null && hurl != "") {
        return hurl;
      } else {
        return "/hotele/hotel.xml";
      }
    },
    getUrlOferta(oferta) {
      let lparams = this.$route.query;
      let adt = 2;
      let chd = 0;
      let inf = 0;
      let chage = "";
      if (lparams["adt"]) {
        adt = Number(lparams["adt"]);
      }
      if (lparams["chd"]) {
        chd = Number(lparams["chd"]);
      }
      if (lparams["inf"]) {
        inf = Number(lparams["inf"]);
      }
      if (lparams["chage"]) {
        chage = lparams["chage"];
      }
      //let link = 'https://www.wyspykanaryjskie.pl/merlinobiektmds-param.xml?xCode=' + oferta.ofr.obj.xCode + '&tourOp=' + oferta.ofr.tourOp + '&htlCode=' + oferta.ofr.obj.code + '&kodId=' + oferta.ofr.id;
      let link =
        this.getHref(oferta.ofr.hurl) +
        "?xCode=" +
        oferta.ofr.obj.xCode +
        "&tourOp=" +
        oferta.ofr.tourOp +
        "&htlCode=" +
        oferta.ofr.obj.code +
        "&kodId=" +
        oferta.ofr.id;
      link += "&adt=" + adt;
      if (chd > 0) {
        link += "&chd=" + chd;
      }
      if (chage != "") {
        link += "&chage=" + chage;
      }
      if (inf > 0) {
        link += "&inf=" + inf;
      }
      let fromDate = this.getFromDate(oferta.ofr.trp.startDate);
      if (fromDate != "") {
        link += "&fromDate=" + fromDate;
      }
      return link;
    },
    getWyzywienie(numer) {
      return this.wyzyw[numer];
    },
    getTourop(tourop) {
      let tourOpName;
      if (tourop != null && tourop != "") {
        let items = this.tourop;
        items.forEach(function (obj) {
          if (obj.kod == tourop) {
            tourOpName = obj.nazwa;
          }
        });
        return tourOpName;
      } else {
        return "";
      }
    },
    onImageError(e) {
      e.target.src = "https://www.travelone.pl/newimgs/zaslepka_lato_zest.jpg";
    },
    getDiscount(x, y) {
      return 100 - (x * 100) / y;
    },
    getMaxPrice(oferta) {
      if (
        oferta.ofr.extra &&
        oferta.ofr.extra.priceHistory &&
        oferta.ofr.extra.priceHistory.max
      ) {
        this.maxprice = oferta.ofr.extra.priceHistory.max;
      }
      return this.maxprice;
    },
    getDiscountPercentage(oferta) {
      if (
        oferta.ofr.extra &&
        oferta.ofr.extra.priceHistory &&
        oferta.ofr.extra.priceHistory.max
      ) {
        let price = oferta.ofr.price;
        let maxprice = oferta.ofr.extra.priceHistory.max;
        if (maxprice != price) {
          this.discount = Math.floor(
            this.getDiscount(Number(price), Number(maxprice))
          );
          return this.discount;
        }
      }
    },
  },
  components: {
    T1CardBreadcrumbs,
    T1Stars,
    T1TripDetails,
  },
};
</script>

<style lang="scss" scoped>
@import "@/components/T1OfferCards/T1CardCommonStyles";
.tab-card {
  &__content {
    flex: 0 1 100%;
    overflow: hidden;
  }

  &__hotel-name {
    font-size: 19px;
  }

  @media (max-width: $screen-xs-max) {
    flex-direction: column;

    &__thumbnail {
      height: 50vw;
      max-height: 220px;
      width: 100%;
    }

    &__content {
      border-radius: 0 0 3px 3px;
      border-width: 0 1px 1px 1px;
    }
  }

  @media (min-width: $screen-xs) {
    &__thumbnail {
      height: 186px;
      max-height: none;
    }
  }

  @media (min-width: $screen-sm) {
    &__thumbnail {
      height: 100%;
      width: 276px;
    }

    &__content {
      border-radius: 0 3px 3px 0;
      border-width: 1px 1px 1px 0;
      padding-left: 16px;
    }
  }

  &__price {
    display: flex;
    align-items: baseline;
    line-height: 1.1;
    margin-left: auto;
    margin-top: auto;
    white-space: nowrap;
  }
}

.image-loader {
  background-color: $gray-00;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  transition: opacity 0.2s ease-in-out;

  &._hiding {
    opacity: 0;
  }
}
</style>
